import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/Booking.css";

import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";

function Booking() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  // ============================================================
  // LANGUAGE
  // ============================================================

  const getLanguageId = () => {
    if (
      typeof language === "number" ||
      !isNaN(Number(language))
    ) {
      return Number(language);
    }

    if (language && typeof language === "object") {
      return (
        Number(
          language.lang_id ||
            language.language_id ||
            language.id
        ) || 1
      );
    }

    return 1;
  };

  const languageId = getLanguageId();

  // ============================================================
  // LOCATIONS
  // ============================================================

  const [locations, setLocations] = useState([]);

  const [loadingLocations, setLoadingLocations] =
    useState(true);

  // ============================================================
  // BOOKING FORM
  // ============================================================

  const [bookingData, setBookingData] = useState({
    cmbPickLocation: "",
    pickdate: "",
    cmbpickHour: "",
    cmbpickmin: "",

    cmbDropLocation: "",
    returndate: "",
    cmbreturnHour: "",
    cmbreturnmin: "",

    clientid: "",
    clientemail: "",
  });

  // ============================================================
  // GET LOCATIONS
  // ============================================================

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLoadingLocations(true);

        console.log(
          "BOOKING LOCATION LANGUAGE:",
          languageId
        );

        const response = await api.get(
          "/locations/getLocations",
          {
            params: {
              city_id: 1,
              lang_id: languageId,
            },
          }
        );

        console.log(
          "BOOKING LOCATIONS RESPONSE:",
          response.data
        );

        const result = response.data;

        if (result?.success && Array.isArray(result.data)) {
          setLocations(result.data);
        } else if (Array.isArray(result)) {
          setLocations(result);
        } else {
          setLocations([]);
        }
      } catch (error) {
        console.error(
          "ERROR FETCHING BOOKING LOCATIONS:",
          error
        );

        setLocations([]);
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchLocations();
  }, [languageId]);

  // ============================================================
  // FALLBACK LOCATIONS
  // Same locations as original HTML
  // ============================================================

  const defaultLocations = [
    {
      location_id: 30,
      id: 30,
      name: "Airport Heraklion",
      location_name: "Airport Heraklion",
    },
    {
      location_id: 29,
      id: 29,
      name: "Airport Chania",
      location_name: "Airport Chania",
    },
    {
      location_id: 28,
      id: 28,
      name: "Airport Sitia",
      location_name: "Airport Sitia",
    },
    {
      location_id: 27,
      id: 27,
      name: "Harbour Heraklion",
      location_name: "Harbour Heraklion",
    },
    {
      location_id: 26,
      id: 26,
      name: "Harbour Chania",
      location_name: "Harbour Chania",
    },
    {
      location_id: 25,
      id: 25,
      name: "Harbour Sitia",
      location_name: "Harbour Sitia",
    },
    {
      location_id: 24,
      id: 24,
      name: "Accommodation (apartment, villa, hotel etc.)",
      location_name:
        "Accommodation (apartment, villa, hotel etc.)",
    },
  ];

  const locationList =
    locations.length > 0
      ? locations
      : defaultLocations;

  // ============================================================
  // HOURS / MINUTES
  // ============================================================

  const hours = Array.from(
    { length: 24 },
    (_, i) => String(i).padStart(2, "0")
  );

  const minutes = ["00", "15", "30", "45"];

  // ============================================================
  // CHANGE HANDLER
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setBookingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ============================================================
  // CONTINUE
  // ============================================================

  const handleContinue = (e) => {
    e.preventDefault();

    console.log(
      "BOOKING DATA:",
      bookingData
    );

    // Basic validation

    if (!bookingData.cmbPickLocation) {
      alert("Please select pickup location.");
      return;
    }

    if (!bookingData.pickdate) {
      alert("Please select pickup date.");
      return;
    }

    if (
      !bookingData.cmbpickHour ||
      !bookingData.cmbpickmin
    ) {
      alert("Please select pickup time.");
      return;
    }

    if (!bookingData.cmbDropLocation) {
      alert("Please select return location.");
      return;
    }

    if (!bookingData.returndate) {
      alert("Please select return date.");
      return;
    }

    if (
      !bookingData.cmbreturnHour ||
      !bookingData.cmbreturnmin
    ) {
      alert("Please select return time.");
      return;
    }

    // ========================================================
    // SAME BOOKING CRITERIA USED IN YOUR EXISTING FLOW
    // ========================================================

    const criteria = {
      cmbPickLocation:
        bookingData.cmbPickLocation,

      pickdate:
        bookingData.pickdate,

      cmbpickHour:
        bookingData.cmbpickHour,

      cmbpickmin:
        bookingData.cmbpickmin,

      cmbDropLocation:
        bookingData.cmbDropLocation,

      returndate:
        bookingData.returndate,

      cmbreturnHour:
        bookingData.cmbreturnHour,

      cmbreturnmin:
        bookingData.cmbreturnmin,

      cmbcartype: "",
      cmbdrvage: "",

      clientid:
        bookingData.clientid,

      clientemail:
        bookingData.clientemail,

      selectedlanguage:
        languageId,
    };

    // ========================================================
    // SAVE EXACTLY LIKE YOUR EXISTING BOOKING FLOW
    // ========================================================

    sessionStorage.setItem(
      "bookingCriteria",
      JSON.stringify(criteria)
    );

    console.log(
      "SAVED BOOKING CRITERIA:",
      criteria
    );

    // Go to existing booking step
    navigate("/bookacar");
  };

  // ============================================================
  // REGULAR CLIENT LOGIN
  // ============================================================

  const handleRegularLogin = (e) => {
    e.preventDefault();

    console.log(
      "Regular client login clicked"
    );

    // Keep this as link/button for now.
    // If you already have a login page, change this route.
    // navigate("/regular-client-login");
  };

  // ============================================================
  // RENDER LOCATION
  // ============================================================

  const getLocationId = (location) => {
    return (
      location.location_id ||
      location.locationid ||
      location.city_id ||
      location.id ||
      location.loc_id
    );
  };

  const getLocationName = (location) => {
    return (
      location.location_name ||
      location.locationname ||
      location.name ||
      location.loc_name ||
      location.title ||
      ""
    );
  };

  // ============================================================
  // RETURN
  // ============================================================

  return (
    <div className="booking-page">

      {/* ======================================================
          BOOKING ENGINE
      ====================================================== */}

      <div className="booking-engine-wrapper hero-wrap ftco-degree-bg">

        <div className="container">

          <div className="row no-gutters slider-text justify-content-start align-items-center justify-content-center booking-slider-row">

            <div className="col-lg-8 booking-engine-column">

              <div className="booking-engine-text">

                <div className="col-md-12 d-flex align-items-center">

                  <form
                    onSubmit={handleContinue}
                    className="request-form booking-request-form bg-primary"
                  >

                    {/* ==================================================
                        PICKUP INFORMATION
                    ================================================== */}

                    <div className="booking-half">

                      <div className="booking-label-row">
                        <label className="label">
                          Pickup Information
                        </label>
                      </div>

                      <div className="booking-full-row">

                        <div className="booking-full-field">

                          <div className="selectParent">

                            <select
                              className="form-control select"
                              name="cmbPickLocation"
                              value={
                                bookingData.cmbPickLocation
                              }
                              onChange={handleChange}
                              disabled={
                                loadingLocations
                              }
                            >

                              <option value="">
                                Select location
                              </option>

                              {locationList.map(
                                (location, index) => (
                                  <option
                                    key={
                                      getLocationId(
                                        location
                                      ) ||
                                      index
                                    }
                                    value={
                                      getLocationId(
                                        location
                                      )
                                    }
                                  >
                                    {getLocationName(
                                      location
                                    )}
                                  </option>
                                )
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                      {/* PICKUP DATE + TIME */}

                      <div className="booking-full-row">

                        <div className="booking-date-field">

                          <div className="form-group">

                            <input
                              type="date"
                              className="calendar form-control"
                              name="pickdate"
                              value={
                                bookingData.pickdate
                              }
                              onChange={handleChange}
                            />

                          </div>

                        </div>

                        <div className="booking-time-field">

                          <div className="time-select-wrapper">

                            <select
                              className="form-control arrow"
                              name="cmbpickHour"
                              value={
                                bookingData.cmbpickHour
                              }
                              onChange={handleChange}
                            >

                              <option value="">
                                Hour
                              </option>

                              {hours.map(
                                (hour) => (
                                  <option
                                    key={hour}
                                    value={hour}
                                  >
                                    {hour}
                                  </option>
                                )
                              )}

                            </select>

                            <span className="time-colon">
                              :
                            </span>

                            <select
                              className="form-control arrow"
                              name="cmbpickmin"
                              value={
                                bookingData.cmbpickmin
                              }
                              onChange={handleChange}
                            >

                              <option value="">
                                Min
                              </option>

                              {minutes.map(
                                (minute) => (
                                  <option
                                    key={minute}
                                    value={minute}
                                  >
                                    {minute}
                                  </option>
                                )
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* ==================================================
                        RETURN INFORMATION
                    ================================================== */}

                    <div className="booking-half">

                      <div className="booking-label-row">
                        <label className="label">
                          Return Information
                        </label>
                      </div>

                      <div className="booking-full-row">

                        <div className="booking-full-field">

                          <div className="selectParent">

                            <select
                              className="form-control select"
                              name="cmbDropLocation"
                              value={
                                bookingData.cmbDropLocation
                              }
                              onChange={handleChange}
                              disabled={
                                loadingLocations
                              }
                            >

                              <option value="">
                                Select location
                              </option>

                              {locationList.map(
                                (location, index) => (
                                  <option
                                    key={
                                      getLocationId(
                                        location
                                      ) ||
                                      index
                                    }
                                    value={
                                      getLocationId(
                                        location
                                      )
                                    }
                                  >
                                    {getLocationName(
                                      location
                                    )}
                                  </option>
                                )
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                      {/* RETURN DATE + TIME */}

                      <div className="booking-full-row">

                        <div className="booking-date-field">

                          <div className="form-group">

                            <input
                              type="date"
                              className="calendar form-control"
                              name="returndate"
                              value={
                                bookingData.returndate
                              }
                              onChange={handleChange}
                            />

                          </div>

                        </div>

                        <div className="booking-time-field">

                          <div className="time-select-wrapper">

                            <select
                              className="form-control arrow"
                              name="cmbreturnHour"
                              value={
                                bookingData.cmbreturnHour
                              }
                              onChange={handleChange}
                            >

                              <option value="">
                                Hour
                              </option>

                              {hours.map(
                                (hour) => (
                                  <option
                                    key={hour}
                                    value={hour}
                                  >
                                    {hour}
                                  </option>
                                )
                              )}

                            </select>

                            <span className="time-colon">
                              :
                            </span>

                            <select
                              className="form-control arrow"
                              name="cmbreturnmin"
                              value={
                                bookingData.cmbreturnmin
                              }
                              onChange={handleChange}
                            >

                              <option value="">
                                Min
                              </option>

                              {minutes.map(
                                (minute) => (
                                  <option
                                    key={minute}
                                    value={minute}
                                  >
                                    {minute}
                                  </option>
                                )
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* ==================================================
                        CONTINUE + REGULAR CLIENT LOGIN
                    ================================================== */}

                    <div className="booking-action-row">

                      <div className="booking-action-half">

                        <div className="form-group">

                          <input
                            type="submit"
                            value="Continue"
                            className="btn btn-secondary1 booking-continue-btn"
                          />

                        </div>

                      </div>

                      <div className="booking-action-half">

                        <a
                          href="#regular-client"
                          onClick={
                            handleRegularLogin
                          }
                          className="btn btn-secondary2 booking-login-btn"
                        >
                          Regular client Login
                        </a>

                      </div>

                    </div>

                    {/* ==================================================
                        REGULAR CLIENT DETAILS
                    ================================================== */}

                    <div className="booking-client-row">

                      {/* CLIENT ID */}

                      <div className="booking-client-half">

                        <div className="form-group">

                          <input
                            type="text"
                            name="clientid"
                            className="frmtxtbox1"
                            maxLength="30"
                            value={
                              bookingData.clientid
                            }
                            onChange={handleChange}
                            placeholder="Client Id. :"
                          />

                          <label>
                            <span className="required-star">
                              *
                            </span>
                            When am I entitled to be a
                            regular client?
                          </label>

                        </div>

                      </div>

                      {/* EMAIL */}

                      <div className="booking-client-half">

                        <div className="form-group">

                          <input
                            type="text"
                            name="clientemail"
                            className="frmtxtbox1"
                            maxLength="100"
                            value={
                              bookingData.clientemail
                            }
                            onChange={handleChange}
                            placeholder="Email Id. :"
                          />

                          <label>
                            <span className="required-star">
                              *
                            </span>
                            I forgot my regular client ID
                          </label>

                        </div>

                      </div>

                    </div>

                  </form>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ======================================================
          EMPTY CONTENT AREA
          SAME AS ORIGINAL HTML
      ====================================================== */}

      <div className="p20 booking-empty-area">

        <div className="container container2 p0">

          <div className="col-md-12 main-content">

            <div className="clearfix"></div>

          </div>

        </div>

      </div>

      {/* ======================================================
          IMPORTANT INFORMATION
      ====================================================== */}

      <div className="ft-bg">

        <div className="why-choose-us-area">

          <div className="container">

            {/* HEADING */}

            <div className="row">

              <div
                className="col-md-12"
                align="center"
              >

                <div className="heading-section heading-section-white">

                  <p className="also-heading">
                    Also
                  </p>

                  <h2
                    className="aboutp"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Important to know
                  </h2>

                </div>

              </div>

            </div>

            {/* ==================================================
                TWO CARDS
            ================================================== */}

            <div className="row">

              {/* ==================================================
                  LEFT CARD
              ================================================== */}

              <div
                className="col-md-6"
                style={{
                  padding: "0",
                }}
              >

                <div className="services services-2 w-100">

                  <div className="pr28 text-1 text w-100">

                    <div className="price-card">

                      <div className="content">

                        <h2>
                          Also important{" "}
                          <span>
                            to know:
                          </span>
                        </h2>

                      </div>

                      <p>
                        Credit card not needed.
                      </p>

                      <p>
                        We have 15 years of
                        experience.
                      </p>

                      <p>
                        We stand for no nonsence
                        car rental.
                      </p>

                      <p>
                        One way rental is free of
                        charge for 10 days or more.
                      </p>

                      <p>
                        We are operational 24 hours
                        a day.
                      </p>

                      <p>
                        We also offer non smoking
                        cars.
                      </p>

                      <div className="clearfix"></div>

                    </div>

                  </div>

                </div>

              </div>

              {/* ==================================================
                  RIGHT CARD
              ================================================== */}

              <div
                className="col-md-6"
                style={{
                  padding: "0",
                }}
              >

                <div className="pr28 services services-2 w-100">

                  <div className="price-card1">

                    {/* ATTENTION */}

                    <div className="content">

                      <h2>
                        <span>
                          Attention!!
                        </span>
                      </h2>

                    </div>

                    <p>
                      Treat your car as your own
                      car.
                      <br />
                      <br />
                      You are not allowed to leave
                      Crete with the car.
                    </p>

                    <div className="clearfix"></div>

                    {/* ENJOY HOLIDAYS */}

                    <div className="content">

                      <h2>
                        Enjoy your
                        <span>
                          holidays
                        </span>
                      </h2>

                    </div>

                    <p>
                      If you have any questions, do
                      not hesitate to contact us
                      <br />
                      <br />
                      from Monday till Friday from
                      09.00 hrs till 16.00 hrs:
                      <br />
                      <br />
                      +319-7010204725 (Whatsapp)
                    </p>

                    <div className="clearfix"></div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default Booking;